import script from "./SignupSummaryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupSummaryModal.vue?vue&type=script&setup=true&lang=js"

import "./SignupSummaryModal.vue?vue&type=style&index=0&id=2fabce2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fabce2a"]])

export default __exports__